import { useQuery } from "@tanstack/react-query";

import apiDal from "../config/apiDal";
import { StorageLocation } from "../types";

const fetchStorageLocation = async (): Promise<StorageLocation[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getStorageLocation",
		bind: {},
	});

	return response.data.result;
};

export const useGetStorageLocation = () => {
	return useQuery<StorageLocation[]>({
		queryKey: ["getStorageLocation"],
		queryFn: () => fetchStorageLocation(),

		select: (data) => data,
	});
};
